import {Dialog, DialogContent} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import AncillaryContent from "./AncillaryContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const AncillaryContainerView = ({
                                    ancillaryId,
                                    open,
                                    setOpen
                                }: { ancillaryId: number, open: boolean, setOpen: Function }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Dialog
            open={open}
            maxWidth={"xl"}
            fullWidth
            onClose={() => {
                setOpen(false);
            }}
        >
            <DialogTitle sx={{m: 0, p: 2}}>
                {t("pricing:ancillaries.sections.ancillary")}
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{padding: 0}}>
                <AncillaryContent readOnly={true} ancillaryId={ancillaryId}/>
            </DialogContent>
        </Dialog>
    );
};

export default AncillaryContainerView;